module.exports = __webpack_public_path__ + "img/login_logo_mckinsey.9fdae6f6.png";